import React, { Fragment, useEffect } from 'react'
import { Grid2 as Grid, Paper, Typography } from '@mui/material'
import {
  Assignment,
  EventNote,
  CheckCircle,
  Store,
  Settings,
  Schedule,
  LockOpen,
  Search
} from '@mui/icons-material'
import { useApi } from '../../../hooks/useApi'
import { getVasRule, getVasRuleDetailList } from '../config/api'
import { VasRuleInfo, VasRuleDetail } from '../../../interfaces/VasRule/VasRule'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../../components/UI'
import { ApiResponse } from '../../../typings/ApiResponse'
import { InfoItem } from '../../../components/InformItem/InformItem'
import { GenericTableV2 } from '../../../components/_EOS/GenericTable/GenericTableV2'
import { usePagination } from '../../../hooks/usePagination'
import { getColumnsVasDetail } from '../config/tableColumns'

interface ViewVasRuleModalProps {
  vasRuleId: number
}

export const ViewVasRuleModal: React.FC<ViewVasRuleModalProps> = ({
  vasRuleId
}) => {
  const { state: vasRuleState, callApi: fetchVasRule } = useApi<VasRuleInfo>()
  const { state: detailsState, callApi: fetchDetails } =
    useApi<ApiResponse<VasRuleDetail>>()

  const pagination = usePagination(5)

  useEffect(() => {
    fetchVasRule(getVasRule(vasRuleId))
  }, [vasRuleId])

  useEffect(() => {
    fetchDetails(
      getVasRuleDetailList(vasRuleId, pagination.page, pagination.pageSize)
    )
  }, [pagination.page, pagination.pageSize])

  const handlePagination = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    pagination.setPagination(auxPage, pageSize)
  }
  const columnsConfig = getColumnsVasDetail()

  if (
    vasRuleState.status === Status.Loading ||
    detailsState.status === Status.Loading
  ) {
    return <Loading />
  }

  const data = vasRuleState.data

  return (
    <Fragment>
      <Grid container spacing={3}>
        <Grid size={6}>
          <InfoItem
            icon={<Assignment />}
            label='Nombre de la Regla'
            value={data?.vasRuleName || '-'}
          />
          <InfoItem
            icon={<EventNote />}
            label='Tipo de VAS *'
            value={data?.typeVasName || '-'}
          />
          <InfoItem
            icon={<CheckCircle />}
            label='Proceso de Aplicación *'
            value={data?.flowVasName || '-'}
          />
          <InfoItem
            icon={<LockOpen />}
            label='Obligatorio / Bloqueante'
            value={data?.isMandatory ? 'Sí' : 'No'}
          />
        </Grid>
        <Grid size={6}>
          <InfoItem
            icon={<Store />}
            label='Tipo de Empaque'
            value={data?.typePackageName || '-'}
          />
          <InfoItem
            icon={<Settings />}
            label='Modo de Validación *'
            value={data?.typeValidationVasName || '-'}
          />
          <InfoItem
            icon={<Schedule />}
            label='Estado'
            value={data?.active ? 'Activo' : 'Inactivo'}
          />
        </Grid>
      </Grid>

      <Paper
        variant='outlined'
        style={{
          width: '100%',
          padding: '16px',
          marginTop: '16px'
        }}
      >
        <Typography
          variant='subtitle1'
          style={{
            fontWeight: 600,
            marginBottom: '8px'
          }}
        >
          Campos Configurados Para Captura
        </Typography>
        <hr
          style={{
            border: 'none',
            borderTop: '1px solid #e0e0e0',
            marginBottom: '16px'
          }}
        />
        <GenericTableV2<VasRuleDetail>
          data={detailsState.data?.items || []}
          emptyMessage='No existen campos configurados para esta regla.'
          emptyIcon={<Search />}
          columns={columnsConfig}
          keyField='vasRuleDetailId'
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            total: detailsState.data?.totalItems || 0,
            onPageChange: handlePagination
          }}
          styling={{
            dense: true,
            hoverEffect: true,
            alternatingRows: true
          }}
        />
      </Paper>
    </Fragment>
  )
}
